import { FaqSection } from '../faq/faq.models';

export const MOCK_FAQ_SECTIONS: FaqSection[] = [
  {
    id: 'source-of-data',
    title: 'Source of data and updated-ness',
    entries: [
      {
        text: 'AskPC sources its data from the internet and from PrivateCircle Database. Hence the data will reflect the updated-ness of the PrivateCircle Research Intelligence Product.',
        children: [
          {
            text: 'Updating any company from AskPC is not possible, because every company update will mean triggering a purchase from MCA - and that will increase the pricing.',
          },
          {
            text: 'AskPC is meant to be a conversation layer on top of PrivateCircle Research products which is trusted by 500+ enterprises in the country.',
          },
          {
            text: 'While our intelligence products are the most updated among peers, it is not possible to keep millions of companies already updated. Hence, our PrivateCircle Research product enables the users to update the data for the ones they want to update.',
          },
          {
            text: 'In case you require updates, we recommend you take an additional subscription to the intelligence products, from where you will be able to update.',
          },
        ],
      },
    ],
  },
  {
    id: 'prompting-techniques',
    title: 'Prompting techniques for optimal token consumption',
    entries: [
      {
        text: "If you know the name of the company / entity, mention that so we don't search for the name of the company and results in lesser tokens.",
        children: [
          {
            text: "If you don't know, then of course we will have to search and get you the information.",
          },
        ],
      },
      {
        text: 'Ask Questions in a detailed manner to get full answer.',
      },
    ],
  },
  {
    id: 'conversation-threads',
    title: 'Use conversation threads effectively for optimal token consumption',
    entries: [
      {
        text: 'Asking multiple questions in the same conversation thread is advisable, if the new question is linked to the previous one.',
      },
      {
        text: 'In case it is an entirely different question or of a different company / investor, please start a New Chat, thereby not adding unnecessary context tokens to the new query.',
      },
    ],
  },
];
export const ASKPC_FAQ_SECTIONS: FaqSection[] = [
  {
    id: 'what-is-askpc',
    title: 'What is AskPC?',
    entries: [
      {
        text: 'AskPC is your AI analyst for Indian private markets, built by PrivateCircle.',
        children: [
          {
            text: 'Instead of navigating MCA portals, NCLT records, and filing PDFs manually, you can simply ask a question and receive structured, research-grade answers instantly.',
          },
          {
            text: 'AskPC covers 3.5M+ companies, 553K+ deals, 5,700+ VC/PE funds, and 2.1M+ debt charges sourced from MCA, NCLT, EPFO, and Stock Exchanges.',
          },
        ],
      },
    ],
  },
  {
    id: 'how-askpc-helps-research',
    title: 'How does AskPC help with Indian private market research?',
    entries: [
      {
        text: 'AskPC compresses hours of research into seconds.',
        children: [
          {
            text: 'Access multi-year financials for 2M+ Indian entities in a single query.',
          },
          {
            text: 'Discover funding rounds from Seed to Late Stage.',
          },
          {
            text: 'Profile VC/PE funds and family offices by AUM and sector preference.',
          },
          {
            text: 'Monitor open charges and insolvency status.',
          },
          {
            text: 'Benchmark companies against industry peers.',
          },
          {
            text: 'Retrieve governance data including management teams, executive remuneration, and cross-directorships through one conversational interface.',
          },
        ],
      },
    ],
  },
  {
    id: 'difference-from-other-ai',
    title: 'How is AskPC different from ChatGPT, Gemini, or Claude?',
    entries: [
      {
        text: 'Generic AI models rely on secondary sources like blogs, news, and outdated press releases.',
        children: [
          {
            text: 'AskPC uses primary data sources such as MCA, NCLT, EPFO, and Stock Exchanges, continuously updated rather than frozen at a training cutoff.',
          },
          {
            text: 'Coverage includes unlisted Indian companies that are not indexed publicly elsewhere.',
          },
          {
            text: 'Financial ratios, multiples, and aggregations are calculated with deterministic financial logic rather than probabilistic AI guesses.',
          },
          {
            text: 'AskPC deeply understands Indian charge structures, MCA filing formats, NCLT proceedings, and Indian accounting standards.',
          },
        ],
      },
    ],
  },
  {
    id: 'reliability',
    title: 'Why is AskPC reliable and trustworthy?',
    entries: [
      {
        text: 'AskPC is built on PrivateCircle’s data infrastructure trusted by Indian financial institutions since 2014.',
        children: [
          {
            text: 'All answers are grounded in auditable primary sources rather than probabilistic reasoning.',
          },
          {
            text: 'The same verified dataset is trusted by 1,000+ financial leaders including PE/VC funds, investment banks, and law firms across India.',
          },
        ],
      },
    ],
  },
  {
    id: 'types-of-queries',
    title: 'What types of queries can AskPC handle?',
    entries: [
      {
        text: 'AskPC supports a wide range of private market research queries.',
        children: [
          {
            text: 'Company deep-dives including financials, shareholding patterns, board composition, and open charges.',
          },
          {
            text: 'Deal research including funding history, M&A transactions, and valuation multiples such as EV/Revenue and EV/EBITDA.',
          },
          {
            text: 'Investor profiling of VC/PE funds, family offices, and HNI portfolios filtered by AUM and investment stage.',
          },
          {
            text: 'Compliance checks including MCA master data, insolvency status, defaulter flags, and charge monitoring.',
          },
          {
            text: 'Market and peer analysis including benchmarking, peer identification, and market sizing.',
          },
          {
            text: 'Governance research including management history, executive remuneration, headcount, and cross-directorships.',
          },
        ],
      },
    ],
  },
  {
    id: 'company-coverage',
    title: 'What Indian companies can I research on AskPC?',
    entries: [
      {
        text: 'AskPC covers more than 3.5M Indian entities.',
        children: [
          {
            text: 'Coverage includes private limited companies, public unlisted companies, LLPs, and listed entities.',
          },
          {
            text: 'You can research startups, MSMEs, unicorns, pre-IPO companies, and subsidiaries of large conglomerates.',
          },
          {
            text: 'Data includes MCA-verified financials, shareholding patterns, charges, and compliance information.',
          },
        ],
      },
    ],
  },
  {
    id: 'pricing',
    title: 'What are the pricing plans — is there a free tier?',
    entries: [
      {
        text: 'AskPC offers 3 million free tokens to get started with no credit card required.',
        children: [
          {
            text: 'The free tier allows users to explore the platform and evaluate verified private market data.',
          },
          {
            text: 'Paid plans are token-based and scale with research usage for individuals, deal teams, and enterprise desks.',
          },
          {
            text: 'All prices are exclusive of GST and can be viewed on askpc.privatecircle.co.',
          },
        ],
      },
    ],
  },
  {
    id: 'integration-api',
    title: 'How do I integrate AskPC, get API access, or contact the team?',
    entries: [
      {
        text: 'AskPC can be accessed through multiple interfaces.',
        children: [
          {
            text: 'Use the web interface at askpc.privatecircle.co.',
          },
          {
            text: 'Use the Chrome plugin to trigger AskPC from any browser tab using right-click.',
          },
          {
            text: 'PrivateCircle offers an API product for programmatic access with the same verified data.',
          },
          {
            text: '<span>For enterprise integrations or support, contact <a href="mailto:support@privatecircle.co">support@privatecircle.co</a> or call <a href="tel:+916364900795">+91 6364900795</a>.</span>',
          },
        ],
      },
    ],
  },
];
